module.exports = __webpack_public_path__ + "static/media/ic_glucose.4e44c322.svg";